

// import React, { useState } from 'react';
// import {
//     Box,
//     Drawer,
//     List,
//     ListItem,
//     ListItemIcon,
//     ListItemText,
//     Collapse,
//     IconButton,
//     Typography,
//     Tooltip,
//     AppBar,
//     Toolbar,
//     useTheme,
//     useMediaQuery,
//     SwipeableDrawer,
// } from '@mui/material';
// import {
//     ExpandLess,
//     ExpandMore,
//     Dashboard,
//     Person,
//     Lock,
//     Business,
//     Group,
//     Article,
//     Help,
//     ChevronLeft,
//     ChevronRight,
//     Menu as MenuIcon,
//     Book,
//     BookOnline,
//     Category,
//     QueryStats,
//     Leaderboard,
// } from '@mui/icons-material';
// import { BookOpenText, LanguagesIcon } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import PageRoutes from '../routes/PageRoutes';
// import PageSideRoute from '../routes/PageSideRoute';

// const drawerWidth = 260;

// const menuItems = [
//     {
//         label: 'Dashboards',
//         icon: <Dashboard />,
//         link: '/display-dashboard'
//     },
//     {
//         label: "Bookings",
//         icon: <Leaderboard />,
//         link: "/display-bookings"
//     },
//     {
//         label: 'Category / Sub Category',
//         icon: <Category />,
//         children: [
//             { label: 'Categories', link: '/display-category' },
//             { label: 'Sub Categories', link: '/display-subcategory' },
//         ],
//     },
//     {
//         label: 'Manage Books', icon: <BookOpenText />,
//         children: [
//             { label: 'Display Books', link: '/display-books' },
//             { label: 'Add Books', link: '/create-edit-books' },
//             { label: 'Display Combos', link: '/display-combos' },
//             { label: 'Add Combos', link: '/create-edit-combos' },
//             { label: "New Releases", link: '/new-release' }
//         ],
//     },
//     {
//         label: 'Authors', icon: <Business />,
//         children: [
//             { label: 'Display Authors', link: '/display-authors' },
//             { label: 'Add Author', link: '/create-edit-authors' }
//         ],
//     },
//     {
//         label: 'Languages', icon: <LanguagesIcon />,
//         children: [
//             { label: 'Display Languages', link: '/display-languages' },
//             { label: 'Add Languages', link: '/create-edit-languages' }
//         ],
//     },
//     {
//         label: 'Blogs', icon: <Article />,
//         children: [
//             { label: 'Display Blogs', link: '/display-blogs' },
//             { label: 'Add Blogs', link: '/create-edit-blogs' }
//         ],
//     },
//     {
//         label: 'Testimonials', icon: <Group />,
//         children: [
//             { label: 'Display Testimonials', link: '/display-testimonials' },
//             { label: 'Add Testimonials', link: '/create-edit-testimonials' }
//         ],
//     },
//     {
//         label: 'FAQ', icon: <Help />,
//         children: [
//             { label: 'Display Faqs', link: '/display-faqs' },
//             { label: 'Add Faqs', link: '/create-edit-faqs' }
//         ]
//     },
//     {
//         label: 'Enquiries', icon: <QueryStats />, link: '/display-enquiry'
//     },
// ];

// const SidebarItem = ({
//     item,
//     openSidebar,
//     depth = 0,
//     selectedItem,
//     setSelectedItem,
//     expandedItems,
//     setExpandedItems,
//     onItemClick,
// }) => {
//     const hasChildren = Array.isArray(item.children);
//     const isExpanded = expandedItems.includes(item.label);

//     const navigate = useNavigate();

//     const handleClick = () => {
//         if (hasChildren) {
//             setExpandedItems((prev) => {
//                 if (depth === 0) {
//                     return isExpanded ? [] : [item.label];
//                 } else {
//                     return isExpanded
//                         ? prev.filter((label) => label !== item.label)
//                         : [...prev, item.label];
//                 }
//             });
//         }

//         if (item.link) {
//             navigate(item.link);
//         }

//         setSelectedItem(item.label);
//         if (onItemClick) onItemClick();
//     };

//     return (
//         <>
//             <Box sx={{ width: '100%' }}>
//                 <Box>
//                     <ListItem
//                         button
//                         onClick={handleClick}
//                         sx={{
//                             backgroundColor: selectedItem === item.label ? 'red' : 'transparent',
//                             '&:hover': {
//                                 backgroundColor:
//                                     selectedItem === item.label ? 'darkred' : 'rgba(255, 255, 255, 0.1)',
//                             },
//                             pl: 2 + depth * 1.5,
//                         }}
//                     >
//                         <Tooltip title={!openSidebar ? item.label : ''} placement="right">
//                             <ListItemIcon sx={{ color: '#fff', minWidth: 40, py: 1 }}>
//                                 {item.icon || <Box sx={{ width: 18 }} />}
//                             </ListItemIcon>
//                         </Tooltip>

//                         {openSidebar && (
//                             <ListItemText primary={item.label}
//                                 primaryTypographyProps={{
//                                     color: '#fff',
//                                     fontSize: depth === 0 ? '1rem' : '0.85rem',
//                                     fontWeight: depth === 0 ? 500 : 400,
//                                 }}
//                             />
//                         )}

//                         {hasChildren && openSidebar && (isExpanded ? <ExpandLess /> : <ExpandMore />)}
//                     </ListItem>

//                     {hasChildren && (
//                         <Collapse in={isExpanded} timeout="auto" unmountOnExit>
//                             <List disablePadding >
//                                 {item.children.map((child, index) => (
//                                     <SidebarItem
//                                         key={index}
//                                         item={child}
//                                         openSidebar={openSidebar}
//                                         depth={depth + 1}
//                                         selectedItem={selectedItem}
//                                         setSelectedItem={setSelectedItem}
//                                         expandedItems={expandedItems}
//                                         setExpandedItems={setExpandedItems}
//                                         onItemClick={onItemClick}
//                                     />
//                                 ))}
//                             </List>
//                         </Collapse>
//                     )}
//                 </Box>
//             </Box>
//         </>
//     );
// };

// const SidebarContent = ({
//     openSidebar,
//     selectedItem,
//     setSelectedItem,
//     expandedItems,
//     setExpandedItems,
//     onItemClick,
// }) => (
//     <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
//         {/* Header */}
//         <Box
//             sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: openSidebar ? 'space-between' : 'center',
//                 p: 2,
//                 minHeight: { sm: 'auto', md: 64 },
//                 bgcolor: 'primary.background',
//                 borderBottom: '1px solid #333',
//             }}
//         >
//             {openSidebar ? (
//                 <Typography variant="h6" fontWeight="bold" color="#fff">
//                     INDIAN BOOK&nbsp;
//                     <Box component="span" color="red">
//                         HOUSE
//                     </Box>
//                 </Typography>
//             ) : (
//                 <Typography variant="h6" fontWeight="bold" color="red" paddingLeft={'28px'}>
//                     I
//                 </Typography>
//             )}
//         </Box>
//         {/* Menu Items */}
//         <List disablePadding >
//             {menuItems.map((item, index) => (
//                 <SidebarItem
//                     key={index}
//                     item={item}
//                     openSidebar={openSidebar}
//                     selectedItem={selectedItem}
//                     setSelectedItem={setSelectedItem}
//                     expandedItems={expandedItems}
//                     setExpandedItems={setExpandedItems}
//                     onItemClick={onItemClick}
//                 />
//             ))}
//         </List>
//     </Box>
// );

// const Sidebar = () => {
//     const [openSidebar, setOpenSidebar] = useState(true);
//     const [selectedItem, setSelectedItem] = useState(null);
//     const [expandedItems, setExpandedItems] = useState([]);
//     const [mobileOpen, setMobileOpen] = useState(false);

//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('md'));

//     // Drawer content for both desktop and mobile
//     const drawerContent = (
//         <SidebarContent
//             openSidebar={openSidebar}
//             selectedItem={selectedItem}
//             setSelectedItem={setSelectedItem}
//             expandedItems={expandedItems}
//             setExpandedItems={setExpandedItems}
//             onItemClick={() => isMobile && setMobileOpen(false)}
//         />
//     );

//     return (
//         <Box sx={{ display: 'flex', minHeight: '100vh' }}>
//             {/* Sidebar and Navbar */}
//             <>
//                 {/* AppBar for mobile */}
//                 {isMobile && (
//                     <AppBar position="fixed" sx={{ zIndex: theme.zIndex.drawer + 1, bgcolor: 'primary.background' }}>
//                         <Toolbar>
//                             <IconButton
//                                 color="inherit"
//                                 edge="start"
//                                 onClick={() => setMobileOpen(prev => !prev)}

//                                 sx={{ mr: 2 }}
//                             >
//                                 <MenuIcon />
//                             </IconButton>
//                             <Typography variant="h6" noWrap component="div">
//                                 INDIAN BOOK&nbsp;
//                                 <Box component="span" color="red">
//                                     HOUSE
//                                 </Box>
//                             </Typography>
//                         </Toolbar>
//                     </AppBar>
//                 )}

//                 {/* Desktop Drawer */}
//                 {!isMobile && (
//                     <Drawer
//                         variant="permanent"
//                         open={openSidebar}
//                         sx={{
//                             width: openSidebar ? drawerWidth : 72,
//                             flexShrink: 0,
//                             '& .MuiDrawer-paper': {
//                                 width: openSidebar ? drawerWidth : 72,
//                                 // transition: 'width 0.3s',
//                                 boxSizing: 'border-box',
//                                 backgroundColor: 'primary.background',
//                                 color: '#fff',
//                                 overflow: 'hidden',
//                             },
//                         }}
//                     >
//                         {/* Header with collapse button */}
//                         <Box
//                             sx={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: openSidebar ? 'space-between' : 'center',
//                                 p: 2,
//                                 minHeight: 64,
//                                 bgcolor: 'primary.background',
//                                 borderBottom: '1px solid #333',
//                             }}
//                         >
//                             {openSidebar ? (
//                                 <Typography variant="h6" fontWeight="bold" color="#fff">
//                                     INDIAN BOOK&nbsp;
//                                     <Box component="span" color="red">
//                                         HOUSE
//                                     </Box>
//                                 </Typography>
//                             ) : (
//                                 <Typography variant="h6" fontWeight="bold" color="red" paddingLeft={'28px'}>
//                                     I
//                                 </Typography>
//                             )}

//                             <IconButton
//                                 onClick={() => setOpenSidebar(!openSidebar)}
//                                 sx={{ color: '#fff', ml: openSidebar ? 0 : 'auto' }}
//                             >
//                                 {openSidebar ? <ChevronLeft /> : <ChevronRight />}
//                             </IconButton>
//                         </Box>
//                         {/* Menu Items */}
//                         <List disablePadding sx={{ overflowY: "scroll", scrollbarWidth: 'none', cursor: 'pointer' }}>
//                             {menuItems.map((item, index) => (
//                                 <SidebarItem

//                                     key={index}
//                                     item={item}
//                                     openSidebar={openSidebar}
//                                     selectedItem={selectedItem}
//                                     setSelectedItem={setSelectedItem}
//                                     expandedItems={expandedItems}
//                                     setExpandedItems={setExpandedItems}
//                                 />
//                             ))}
//                         </List>
//                     </Drawer>
//                 )}

//                 {/* Mobile Drawer */}
//                 {isMobile && (
//                     <SwipeableDrawer
//                         anchor="left"
//                         open={mobileOpen}
//                         onOpen={() => setMobileOpen(true)}
//                         onClose={() => setMobileOpen(false)}
//                         sx={{
//                             '& .MuiDrawer-paper': {
//                                 width: drawerWidth,
//                                 backgroundColor: 'primary.background',
//                                 color: '#fff',
//                             },
//                         }}
//                     >
//                         {drawerContent}
//                     </SwipeableDrawer>
//                 )}
//             </>

//             {/* Main Content */}
//             <Box
//                 component="main"
//                 sx={{
//                     flexGrow: 1,
//                     width: '100%',
//                     mt: isMobile ? '64px' : 0,
//                     transition: 'margin 0.3s',
//                 }}
//             >
//                 <PageRoutes />
//             </Box>
//         </Box>
//     );
// };
// export default Sidebar


import React, { useState, useEffect } from 'react';
import {
    Box,
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Collapse,
    IconButton,
    Typography,
    Tooltip,
    AppBar,
    Toolbar,
    useTheme,
    useMediaQuery,
    SwipeableDrawer,
} from '@mui/material';
import {
    ExpandLess,
    ExpandMore,
    Dashboard,
    Person,
    Lock,
    Business,
    Group,
    Article,
    Help,
    ChevronLeft,
    ChevronRight,
    Menu as MenuIcon,
    Book,
    BookOnline,
    Category,
    QueryStats,
    Leaderboard,
} from '@mui/icons-material';
import { BookOpenText, LanguagesIcon, User } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import PageRoutes from '../routes/PageRoutes';
import PageSideRoute from '../routes/PageSideRoute';

const drawerWidth = 260;

const menuItems = [
    {
        label: 'Dashboards',
        icon: <Dashboard />,
        link: '/'
    },
    {
        label: 'Users',
        icon: <User />,
        link: '/users'
    },
    {
        label: "Bookings",
        icon: <Leaderboard />,
        link: "/display-bookings"
    },
    {
        label: 'Category / Sub Category',
        icon: <Category />,
        children: [
            { label: 'Categories', link: '/display-category' },
            { label: 'Sub Categories', link: '/display-subcategory' },
        ],
    },
    {
        label: 'Manage Books', icon: <BookOpenText />,
        children: [
            { label: 'Display Books', link: '/display-books' },
            { label: 'Add Books', link: '/create-edit-books' },
            { label: 'Display Combos', link: '/display-combos' },
            { label: 'Add Combos', link: '/create-edit-combos' },
            { label: "Upcoming", link: '/new-release' }
        ],
    },
    {
        label: 'Authors', icon: <Business />,
        children: [
            { label: 'Display Authors', link: '/display-authors' },
            { label: 'Add Author', link: '/create-edit-authors' }
        ],
    },
    {
        label: 'Languages', icon: <LanguagesIcon />,
        children: [
            { label: 'Display Languages', link: '/display-languages' },
            { label: 'Add Languages', link: '/create-edit-languages' }
        ],
    },
    {
        label: 'Blogs', icon: <Article />,
        children: [
            { label: 'Display Blogs', link: '/display-blogs' },
            { label: 'Add Blogs', link: '/create-edit-blogs' }
        ],
    },
    {
        label: 'Testimonials', icon: <Group />,
        children: [
            { label: 'Display Testimonials', link: '/display-testimonials' },
            { label: 'Add Testimonials', link: '/create-edit-testimonials' }
        ],
    },
    {
        label: 'FAQ', icon: <Help />,
        children: [
            { label: 'Display Faqs', link: '/display-faqs' },
            { label: 'Add Faqs', link: '/create-edit-faqs' }
        ]
    },
    {
        label: 'Enquiries', icon: <QueryStats />, link: '/display-enquiry'
    },
];

const SidebarItem = ({
    item,
    openSidebar,
    depth = 0,
    selectedItem,
    setSelectedItem,
    expandedItems,
    setExpandedItems,
    onItemClick,
}) => {
    const hasChildren = Array.isArray(item.children);
    const isExpanded = expandedItems.includes(item.label);

    const navigate = useNavigate();

    const handleClick = () => {
        if (hasChildren) {
            setExpandedItems((prev) => {
                if (depth === 0) {
                    return isExpanded ? [] : [item.label];
                } else {
                    return isExpanded
                        ? prev.filter((label) => label !== item.label)
                        : [...prev, item.label];
                }
            });
        }

        if (item.link) {
            navigate(item.link);
        }

        setSelectedItem(item.label);
        if (onItemClick) onItemClick();
    };

    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Box>
                    <ListItem
                        button
                        onClick={handleClick}
                        sx={{
                            backgroundColor: selectedItem === item.label ? 'red' : 'transparent',
                            '&:hover': {
                                backgroundColor:
                                    selectedItem === item.label ? 'darkred' : '#FFFFFF1A',
                            },
                            pl: 2 + depth * 1.5,
                        }}
                    >
                        <Tooltip title={!openSidebar ? item.label : ''} placement="right">
                            <ListItemIcon sx={{ color: '#fff', minWidth: 40, py: 1 }}>
                                {item.icon || <Box sx={{ width: 18 }} />}
                            </ListItemIcon>
                        </Tooltip>

                        {openSidebar && (
                            <ListItemText primary={item.label}
                                primaryTypographyProps={{
                                    color: '#fff',
                                    fontSize: depth === 0 ? '1rem' : '0.85rem',
                                    fontWeight: depth === 0 ? 500 : 400,
                                }}
                            />
                        )}

                        {hasChildren && openSidebar && (isExpanded ? <ExpandLess /> : <ExpandMore />)}
                    </ListItem>

                    {hasChildren && (
                        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                            <List disablePadding >
                                {item.children.map((child, index) => (
                                    <SidebarItem
                                        key={index}
                                        item={child}
                                        openSidebar={openSidebar}
                                        depth={depth + 1}
                                        selectedItem={selectedItem}
                                        setSelectedItem={setSelectedItem}
                                        expandedItems={expandedItems}
                                        setExpandedItems={setExpandedItems}
                                        onItemClick={onItemClick}
                                    />
                                ))}
                            </List>
                        </Collapse>
                    )}
                </Box>
            </Box>
        </>
    );
};

const SidebarContent = ({
    openSidebar,
    selectedItem,
    setSelectedItem,
    expandedItems,
    setExpandedItems,
    onItemClick,
}) => (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* Header */}
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: openSidebar ? 'space-between' : 'center',
                p: 2,
                minHeight: { sm: 'auto', md: 64 },
                bgcolor: 'primary.background',
                borderBottom: '1px solid #333',
            }}
        >
            {openSidebar ? (
                <Typography variant="h6" fontWeight="bold" color="#fff">
                    INDIAN BOOK&nbsp;
                    <Box component="span" color="red">
                        HOUSE
                    </Box>
                </Typography>
            ) : (
                <Typography variant="h6" fontWeight="bold" color="red" paddingLeft={'28px'}>
                    I
                </Typography>
            )}
        </Box>
        {/* Menu Items */}
        <List disablePadding >
            {menuItems.map((item, index) => (
                <SidebarItem
                    key={index}
                    item={item}
                    openSidebar={openSidebar}
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}
                    expandedItems={expandedItems}
                    setExpandedItems={setExpandedItems}
                    onItemClick={onItemClick}
                />
            ))}
        </List>
    </Box>
);

const Sidebar = () => {
    const [openSidebar, setOpenSidebar] = useState(true);
    const [selectedItem, setSelectedItem] = useState(null);
    const [expandedItems, setExpandedItems] = useState([]);
    const [mobileOpen, setMobileOpen] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const location = useLocation(); // Get the current location

    // Update selectedItem based on the current path
    useEffect(() => {
        const currentPath = location.pathname;
        const activeItem = menuItems.find(item => item.link === currentPath) ||
            menuItems.flatMap(item => item.children || []).find(child => child.link === currentPath);

        if (activeItem) {
            setSelectedItem(activeItem.label);
        }
    }, [location.pathname]);

    // Drawer content for both desktop and mobile
    const drawerContent = (
        <SidebarContent
            openSidebar={openSidebar}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            expandedItems={expandedItems}
            setExpandedItems={setExpandedItems}
            onItemClick={() => isMobile && setMobileOpen(false)}
        />
    );

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            {/* Sidebar and Navbar */}
            <>
                {/* AppBar for mobile */}
                {isMobile && (
                    <AppBar position="fixed" sx={{ zIndex: theme.zIndex.drawer + 1, bgcolor: 'primary.background' }}>
                        <Toolbar>
                            <IconButton
                                color="inherit"
                                edge="start"
                                onClick={() => setMobileOpen(prev => !prev)}
                                sx={{ mr: 2 }}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Typography variant="h6" noWrap component="div">
                                INDIAN BOOK&nbsp;
                                <Box component="span" color="red">
                                    HOUSE
                                </Box>
                            </Typography>
                        </Toolbar>
                    </AppBar>
                )}

                {/* Desktop Drawer */}
                {!isMobile && (
                    <Drawer
                        variant="permanent"
                        open={openSidebar}
                        sx={{
                            width: openSidebar ? drawerWidth : 72,
                            flexShrink: 0,
                            '& .MuiDrawer-paper': {
                                width: openSidebar ? drawerWidth : 72,
                                boxSizing: 'border-box',
                                backgroundColor: 'primary.background',
                                color: '#fff',
                                overflow: 'hidden',
                            },
                        }}
                    >
                        {/* Header with collapse button */}
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: openSidebar ? 'space-between' : 'center',
                                p: 2,
                                minHeight: 64,
                                bgcolor: 'primary.background',
                                borderBottom: '1px solid #333',
                            }}
                        >
                            {openSidebar ? (
                                <Typography variant="h6" fontWeight="bold" color="#fff">
                                    INDIAN BOOK&nbsp;
                                    <Box component="span" color="red">
                                        HOUSE
                                    </Box>
                                </Typography>
                            ) : (
                                <Typography variant="h6" fontWeight="bold" color="red" paddingLeft={'28px'}>
                                    I
                                </Typography>
                            )}

                            <IconButton
                                onClick={() => setOpenSidebar(!openSidebar)}
                                sx={{ color: '#fff', ml: openSidebar ? 0 : 'auto' }}
                            >
                                {openSidebar ? <ChevronLeft /> : <ChevronRight />}
                            </IconButton>
                        </Box>
                        {/* Menu Items */}
                        <List disablePadding sx={{ overflowY: "scroll", scrollbarWidth: 'none', cursor: 'pointer' }}>
                            {menuItems.map((item, index) => (
                                <SidebarItem
                                    key={index}
                                    item={item}
                                    openSidebar={openSidebar}
                                    selectedItem={selectedItem}
                                    setSelectedItem={setSelectedItem}
                                    expandedItems={expandedItems}
                                    setExpandedItems={setExpandedItems}
                                />
                            ))}
                        </List>
                    </Drawer>
                )}

                {/* Mobile Drawer */}
                {isMobile && (
                    <SwipeableDrawer
                        anchor="left"
                        open={mobileOpen}
                        onOpen={() => setMobileOpen(true)}
                        onClose={() => setMobileOpen(false)}
                        sx={{
                            '& .MuiDrawer-paper': {
                                width: drawerWidth,
                                backgroundColor: 'primary.background',
                                color: '#fff',
                            },
                        }}
                    >
                        {drawerContent}
                    </SwipeableDrawer>
                )}
            </>

            {/* Main Content */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    width: '100%',
                    mt: isMobile ? '64px' : 0,
                    transition: 'margin 0.3s',
                }}
            >
                <PageRoutes />
            </Box>
        </Box>
    );
};

export default Sidebar;
